/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginContext } from '../../../../App';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';
import deviceInfo from '../../../../libs/BrowserDevices';
import { LanguageContext } from '../../../../libs/Context';
import { userFullName } from '../../../../libs/HelperContent';
import { deviceAndLocation, getMeetingsList, getPublicMeetingData } from '../../../actions/meeting_actions';
import MeetingJoin from '../../../Meetings/Components/MeetingJoin';
import SharePost from '../../../NewsFeed/components/SharePost';

const WebinarVc = () =>
{
	const { socket } = useContext(LoginContext);
	const { language } = useContext(LanguageContext);
	const session = useSelector((state:any) => state?.mysession?.session);
	const { type = '', session:sessionId = '' } = useParams(); // sessionid from params will be encoded
	const location = useLocation();
	const navigate = useNavigate();
	const [ webinar, setWebinar ] = useState(location?.state || {});
	const [ share, setShare ] = useState<any>(null);
	const device = deviceInfo();
	const [ isLoading, setIsLoading ] = useState(true);
	const withRegistration = typeof webinar?.withRegistration === 'boolean'
		? window.btoa(webinar?.withRegistration)
		: new URLSearchParams(window.location.search).get('withRegistration'); // will get encoded value

	const joinUrlWithRegistration = new URLSearchParams(window.location.search).get('joinUrlWithRegistration');

	const joinUrlParam = ((withRegistration && type !== 'register') || joinUrlWithRegistration) ? `&joinUrlWithRegistration=${window.btoa(String(withRegistration))}` : '';

	console.log(withRegistration);
	const handleLoad = () =>
	{
		setIsLoading(false);
	};
	// const webinar = location?.state || {};
	const isLoggedIn = Object?.keys(session)?.length > 0;
	const decodedSessionId = sessionId ? window.atob(sessionId) : '';
	const displayName:any = isLoggedIn
		? userFullName(session)
		: '';
	const name:any = displayName;
	const nameQuery = name ? `&displayName=${window.btoa(displayName)}` : '';
	const email:any = isLoggedIn ? window.btoa(session?.email) : '';
	const emailQuery = email ? `&uid=${email}` : '';
	const environmentParam = `env=${process.env.REACT_APP_STAGE}`;
	const userIdParam = `profileKey=${session?.userId || ''}`;

	const registerUrl = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}register?id=${webinar?.meetingId || webinar?._id}&sessionId=${decodedSessionId}&${environmentParam}&${userIdParam}&withRegistration=${withRegistration || window.btoa('false')}${joinUrlParam}`;
	const hostUrl = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}${decodedSessionId}?${environmentParam}&${userIdParam}&projectId=${process.env.REACT_APP_VIDEO_ID}${nameQuery}${emailQuery}&meetingType=${window.btoa('webinar')}&lan=en&groupId=${session?.companyId ?? ''}${joinUrlParam}`;

	const saveUserLocation = async () =>
	{
		let CountryName = '';

		try
		{
			const response = await fetch(process.env.REACT_APP_INMEET_LOCATION || '');
			const data = await response.json();

			CountryName = data?.country || '';
		}
		catch (err)
		{
			console.error('failed to get user location', err);
		}
		const body:any = {
			// licenseTo    : props?.licenseDetails?.licenseObj?.licenseTo,
			meetingId    : webinar?.meetingId || webinar?._id,
			sessionId    : decodedSessionId,
			scheduledBy  : webinar?.scheduledBy,
			startTimeUTC : webinar?.startTimeUTC,
			endTimeUTC   : webinar?.endTimeUTC,
			deviceInfo   : device.platform,
			location     : CountryName,
			scheduleType : 'webinar'
		};

		if (webinar?.groupId) body.groupId = webinar.groupId;

		return deviceAndLocation(body) // function for meeting insights by location method(post)
			.then((res) =>
			{
				if (res.status === true)
				{
					console.log('success');
				}

				return res.status && 'true';
			})
			.catch((err) =>
			{
				console.log('error FOR FETCH LOCATION', err);

				return 'false';
			});
	};

	const isWebinarCancelled = (data = null) =>
	{
		const newData = data || webinar;

		if (newData?.status === 4 || newData?.deleteStatus)
		{
			toast.error('The webinar has been cancelled', {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			// navigate(`${process.env.REACT_APP_WEB_LINK }/webinars`, { replace: true }); // needed to replace the whole url
			navigate(-1);

			return true;
		}

		return false;
	};

	const getUrl = () =>
	{
		if (type === 'register') // displaying register url in inmeet and checking below if registration required or not
		{
			// Calculate registerUrl dynamically when webinar data is available
			const dynamicRegisterUrl = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}register?id=${webinar?.meetingId || webinar?._id || ''}&sessionId=${decodedSessionId}&${environmentParam}&${userIdParam}&withRegistration=${withRegistration || window.btoa('false')}${joinUrlParam}`;

			console.log('📍 Dynamic registerUrl:', dynamicRegisterUrl, 'webinar:', webinar);

			return dynamicRegisterUrl;
		}
		else if (type === 'join')
		{
			saveUserLocation();
			let joineeUrl = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}welcome?${environmentParam}&${userIdParam}&id=${webinar?.meetingId || webinar?._id}&sessionId=${decodedSessionId}${joinUrlParam}`;
			// &uid=${joineeEmail}&name=${joineeName}`;
			const encodedName = new URLSearchParams(window.location.search).get('name');
			const encodedEmail = new URLSearchParams(window.location.search).get('email');

			const registeredName = encodedName ? atob(encodedName) : null;

			if (isLoggedIn)
			{
				isWebinarCancelled();
				if (webinar?.scheduledBy === session?.userId) // checking if this is host
				{
					// Calculate hostUrl dynamically
					const dynamicHostUrl = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}${decodedSessionId}?${environmentParam}&${userIdParam}&projectId=${process.env.REACT_APP_VIDEO_ID}${nameQuery}${emailQuery}&meetingType=${window.btoa('webinar')}&lan=en&groupId=${session?.companyId ?? ''}${joinUrlParam}`;

					return dynamicHostUrl;
				}
				else if (webinar?.withRegistration && webinar?.isRegistered)
				{
					joineeUrl = joineeUrl.concat(`&name=${userFullName(session)}`).concat(`&uid=${window.btoa(session.email)}`);

					return joineeUrl;
				}
				else if (encodedEmail && registeredName)
				{
					joineeUrl = joineeUrl.concat(`&name=${registeredName}`).concat(`&uid=${encodedEmail}`);

					return joineeUrl;
				}

				// Return dynamic registerUrl for fallback
				return `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}register?id=${webinar?.meetingId || webinar?._id || ''}&sessionId=${decodedSessionId}&${environmentParam}&${userIdParam}&withRegistration=${withRegistration || window.btoa('false')}${joinUrlParam}`;
			}
			// below user not logged in
			else if (encodedEmail && registeredName)
			{
				joineeUrl = joineeUrl.concat(`&name=${registeredName}`).concat(`&uid=${encodedEmail}`);

				return joineeUrl;
			}

			// Return dynamic registerUrl for non-logged in users
			return `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}register?id=${webinar?.meetingId || webinar?._id || ''}&sessionId=${decodedSessionId}&${environmentParam}&${userIdParam}&withRegistration=${withRegistration || window.btoa('false')}${joinUrlParam}`;
		}
		else if (type === 'speaker')
		{
			saveUserLocation();
			let speakerUrlNew = `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}${decodedSessionId}?${environmentParam}&${userIdParam}&projectId=${process.env.REACT_APP_VIDEO_ID}&meetingType=${window.btoa('webinar')}&lan=en${joinUrlParam}`; // session id required in path

			if (isLoggedIn)
			{
				isWebinarCancelled();
				speakerUrlNew += `&displayName=${window.btoa(userFullName(session))}`;
				speakerUrlNew += `&uid=${window.btoa(session.email)}`;
			}
			else
			{
				speakerUrlNew += '&displayName=';
				speakerUrlNew += '&uid=Z3Vlc3Q=';
			}

			return speakerUrlNew;
		}
		else if (type === 'share')
		{
			const scheduleType:any = new URLSearchParams(window.location.search).get('scheduleType');
			const screenShareUrl = `${process.env.REACT_APP_SHARESCREEN__INMEET}${webinar?.sessionId}?${environmentParam}&${userIdParam}&projectId=${process.env.REACT_APP_VIDEO_ID}&displayName=${displayName}${emailQuery}&meetingType=${window.btoa(scheduleType)}&screenshare=true${joinUrlParam}`;

			return screenShareUrl;
		}
		else
		{
			navigate(-1);
		}
	};
	const url = getUrl();

	const getWebinarData = async () =>
	{
		try
		{
			const queryParams:any = {
				id   : decodedSessionId,
				type : 'webinar'

			};

			const res = isLoggedIn ? await getMeetingsList(queryParams) : await getPublicMeetingData(queryParams);
			const apiResponse = res?.data?.meetingDetails || res?.data?.data?.meetingDetails;
			const apiStatus = res?.status || res?.data?.status;

			if (apiStatus)
			{
				isWebinarCancelled(apiResponse);

				setWebinar(apiResponse);
				setIsLoading(false);
			}
			else
			{
				setWebinar({});
				setIsLoading(false);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('======================>', err);
			setWebinar({});
			setIsLoading(false);
		}
	};

	const checkEvent = (data) =>
	{
		if (typeof data !== 'string') return false;

		if (data === 'JOIN_VC_CANCEL') return true;

		try
		{
			const parsedData = JSON.parse(data);

			if (parsedData?.key && parsedData?.key === 'sharingMeetingDetails')
			{
				setShare(parsedData);
			}
			if (parsedData.cmd)
			{
				return Boolean(parsedData.cmd === 'END_STATUS');
			}
			else
			{
				return false;
			}
		}
		catch
		{
			return false;
		}
	};

	useEffect(() =>
	{
		if (Object.keys(webinar || {}).length === 0 && decodedSessionId) getWebinarData();
		const handleEvent = (event:any) =>
		{
			// eslint-disable-next-line no-console
			console.log('event', event);

			if (checkEvent(event.data))
			{
				navigate('/webinars');
			}
		};

		window.addEventListener('message', handleEvent);

		return () =>
		{
			window.removeEventListener('message', handleEvent);
		};
	}, []);

	useEffect(() =>
	{
		getWebinarData();
	}, []);

	// useEffect(() =>
	// {
	// 	if (socket)
	// 	{
	// 		socket.on('exit_training', (data:any) =>
	// 		{
	// 			if (data)
	// 			{
	// 				console.log('inside-----------------');
	// 				navigate('/webinars');
	// 			}
	// 		});

	// 		return () =>
	// 		{
	// 			socket.off('exit_training');
	// 		};
	// 	}
	// }, [ socket ]);

	const HandleClose = () =>
	{
		console.log('ins---------------------');
		setWebinar((prev) => ({ ...prev, meetingPassword: '' }));
		navigate('/webinars');
	};

	const handleConfirm = () =>
	{
		setWebinar((prev) => ({ ...prev, meetingPassword: '' }));
		setIsLoading(true);
	};

	return (
		<div className='flexRow webinarJoinScreen alignCntr justifyCntr'>
			<div className='flexCol webinarFullScreen justifyBtwn'>
				{isLoading && <Loading />}
				{webinar?.meetingPassword && type === 'speaker'
					? 	(
						<MeetingJoin
							openTime={webinar?.meetingPassword}
							heading={'Enter Webinar Password'}
							acceptBtn={language?.joinWebinar}
							meetingId={webinar?.uniqueMeetingID}
							from='join'
							handleClosePopup={HandleClose}
							handleConfirm={handleConfirm}
							isPassword={webinar?.meetingPassword}
						/>
					)
					: 					(
						<iframe
							title='hostscreen'
							id='conference'
							allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; camera; microphone; fullscreen; speaker; display-capture'
							src={url}
							style={{ height: 'var(--percent100)', width: 'var(--percent100)', border: 0, display: isLoading ? 'none' : 'block' }}
							onLoad={handleLoad}
						/>
					)
				}
				<div className={share ? 'flexCol fxdSocialMediaSlider slideIn' : 'displayNone'} >
					{share && Object?.keys(share)?.length > 0 &&
						<SharePost meetingVC={share?.value?.shareLink} handleCloseShare={() => setShare(null)} mediaData={{ _id: decodedSessionId }} type='meetingVC'/>
					}
				</div>
			</div>
		</div>
	);
};

export default WebinarVc;